/* src/app/video-detail/video-detail.component.scss */
.video-detail-layout {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.video-detail-form {
  flex: 1 1 auto;
  min-width: 0;
}
.video-detail-preview {
  flex: 0 0 auto;
  width: 320px;
}
input,
select,
textarea {
  height: 30px;
  padding: 2px 5px;
  font-size: 1rem;
  width: 100%;
}
.preview-video {
  display: block;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 4px;
  background: #000;
}
.vimeo-preview {
  margin-bottom: 12px;
}
.preview-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 16/9;
  box-sizing: border-box;
  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  color: #777;
  font-size: 0.85rem;
  text-align: center;
}
.thumbnail-preview {
  display: block;
  margin-top: 10px;
  max-width: 160px;
  max-height: 90px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.save-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.save-btn.state-success {
  color: #6dcc09;
  border-color: #6dcc09;
}
/*# sourceMappingURL=video-detail.component.css.map */
